const header = () => {
    return ( 
        <header>
            <div class='profile'></div>
            {/* <h1>Static Buzz</h1> */}
            <p className="mb-0">explore below</p>
        </header>
     );
}
 
export default header;